import { api, inWindow } from 'api';
const systemApi = api.getSystemApi();
const inElectron = systemApi.isElectron();
const isWebWmEntry = systemApi.isWebWmEntry();
const isDev = () => inWindow() && ((window === null || window === void 0 ? void 0 : window.location.href.includes('su-desktop-web')) || (window === null || window === void 0 ? void 0 : window.location.href.includes('su-desktop-web.office.163.com')));
export const lookLikeInElectron = inElectron || (isDev() && !isWebWmEntry);
export const HIDDEN_MENU_LABEL_MAP = {
    FREIGHT_FORWARDING_IC_SEARCH: true,
    FREIGHT_FORWARDING_AI_SEARCH: true,
};
export const HIDDEN_MENU_LABEL_MAP_2 = {
    ORG_SETTINGS_REPAYMENT_REGISTER: true,
};
export const HIDDEN_MENU_LABEL_MAP_3 = {
    ORG_SETTINGS_REVIEW_FLOW: true,
};
export const STANDARD_VERSION_HIDDEN_MENU_LABEL = {
    AI_ASSISTANT_AGENT: true,
};
export const ALL_HIDDEN_MENU_LABEL_MAP = Object.assign(Object.assign({}, HIDDEN_MENU_LABEL_MAP), HIDDEN_MENU_LABEL_MAP_2);
export const checkHasAiTeam = (menus) => {
    const hasAiTeam = menus.some(menu => {
        var _a;
        return (_a = menu.subMenuItems) === null || _a === void 0 ? void 0 : _a.some(subMenu => {
            return subMenu.menuLabel === 'PERSONAL_AI_TEAM' || subMenu.menuLabel === 'ALL_AI_TEAM';
        });
    });
    return hasAiTeam;
};
export const AI_STFF_HIDDEN_MENU_LABEL_MAP = {
    AI_STAFF: true,
    AI_ASSISTANT_AGENT: true,
    PERSONAL_AI_STAFF: true,
    ALL_AI_STAFF: true,
};
export const genTreeDataByMenu = (menuData, invalidPermissionMap = {}) => {
    if (!menuData || menuData.length === 0) {
        return [];
    }
    const result = [];
    menuData.forEach(v => {
        if (!invalidPermissionMap[v.label]) {
            const children = genTreeDataByMenu(v.children || [], invalidPermissionMap);
            result.push({
                title: v.name,
                key: v.label || '',
                children,
                isLeaf: !v.children || v.children.length === 0,
            });
        }
    });
    return result;
};
export const flattenMenuTreeData = (menuData, invalidPermissionMap = {}, level = 1) => {
    if (!menuData || menuData.length === 0) {
        return [];
    }
    const result = [];
    menuData.forEach(v => {
        if (!invalidPermissionMap[v.menuLabel]) {
            result.push({
                menuLabel: v.menuLabel,
                menuName: v.menuName,
                showMenu: v.showMenu,
                hidden: v.hidden,
                level,
                isLeaf: !v.subMenuItems || v.subMenuItems.length === 0,
            });
            if (v.subMenuItems) {
                result.push(...flattenMenuTreeData(v.subMenuItems, invalidPermissionMap, level + 1));
            }
        }
    });
    return result;
};
export const filterAndSortBadgeByPath = (path, menuBadgeList, config) => {
    const textResult = [];
    const selfNumResult = [];
    const childNumResult = [];
    const { menuKeys, comp, condition: conditionInStore } = config;
    menuBadgeList
        .filter(v => {
        const { activeDays = 90, registerTime, removeTime, compPosition, contentType, label, condition, path, rootPath } = v;
        if (![path, rootPath].includes(path)) {
            return false;
        }
        const active = contentType === 'num' || (!removeTime && Date.now() - registerTime < activeDays * 24 * 60 * 60 * 1000);
        if (!active) {
            return false;
        }
        if (Array.isArray(compPosition) && compPosition.length > 0) {
            const availableComp = compPosition.includes(comp);
            if (!availableComp) {
                return false;
            }
        }
        if (label && !menuKeys[label]) {
            return false;
        }
        return findMenuBadgeConditionOk(conditionInStore, condition);
    })
        .forEach(v => {
        const isSelf = v.path === path;
        const isChild = v.rootPath === path;
        const isText = v.contentType === 'text';
        const isNum = v.contentType === 'num';
        if (isSelf || isChild) {
            if (isSelf && isText) {
                textResult.push(v);
            }
            else if (isNum) {
                if (isSelf) {
                    selfNumResult.push(v);
                }
                else {
                    childNumResult.push(v);
                }
            }
        }
    });
    let res = {
        type: 'childNum',
        result: childNumResult,
    };
    if (textResult.length > 0) {
        res = {
            type: 'text',
            result: textResult,
        };
    }
    else if (selfNumResult.length > 0) {
        res = {
            type: 'selfNum',
            result: selfNumResult,
        };
    }
    return {
        type: res.type,
        result: res.result.sort((a, b) => (b.priority || 0) - (a.priority || 0)),
    };
};
export const getMenuBadgeConfigsFromMenus = (menus, rootPath) => {
    const result = [];
    menus.forEach(menu => {
        if (menu.badgeConfig && menu.badgeConfig.length > 0) {
            const temp = menu.badgeConfig.map(v => (Object.assign(Object.assign({}, v), { label: menu.label, path: menu.path, rootPath: rootPath !== null && rootPath !== void 0 ? rootPath : menu.path })));
            result.push(...temp);
        }
        if (menu.children && menu.children.length > 0) {
            result.push(...getMenuBadgeConfigsFromMenus(menu.children, rootPath !== null && rootPath !== void 0 ? rootPath : menu.path));
        }
    });
    return result;
};
export const isConditionOk = (standard, condition) => {
    if (condition === undefined) {
        return true;
    }
    if (condition && standard) {
        return true;
    }
    if (!condition && !standard) {
        return true;
    }
    return false;
};
export const findMenuBadgeConditionOk = (inStore, condition) => {
    if (!condition) {
        return true;
    }
    if (!isConditionOk(inStore.isUltimateVersion, condition.isUltimateVersion)) {
        return false;
    }
    if (!isConditionOk(inStore.isExaltedVersion, condition.isExaltedVersion)) {
        return false;
    }
    if (!isConditionOk(inStore.higherOrEqualUltimateVersion, condition.higherOrEqualUltimateVersion)) {
        return false;
    }
    if (!isConditionOk(inStore.isAdmin, condition.isAdmin)) {
        return false;
    }
    if (!isConditionOk(inStore.isNewUser, condition.isNewUser)) {
        return false;
    }
    if (Array.isArray(condition.excludeProductVersion) &&
        (!inStore.productVersion || condition.excludeProductVersion.includes(inStore.productVersion))) {
        return false;
    }
    return true;
};
export const getNewMenuBadgeList = (menuBadgeList, { path, content, styleType, id }) => menuBadgeList.map(item => {
    const bool = id ? id === item.originId && item.path === path : item.path === path;
    if (bool) {
        if (item.contentType === 'num') {
            return Object.assign(Object.assign({}, item), { content });
        }
        else if (item.contentType === 'text') {
            return Object.assign(Object.assign({}, item), { content, styleType: styleType !== null && styleType !== void 0 ? styleType : item.styleType });
        }
    }
    return item;
});
export const filterCommonMenus = (menus, filterConditions) => {
    const result = menus
        .filter(v => {
        var _a;
        if (filterConditions.hiddenInTopMenu && ((_a = v.webConfig) === null || _a === void 0 ? void 0 : _a.hiddenInTopMenu)) {
            return false;
        }
        if (v.label && !filterConditions.menuKeys[v.label]) {
            return false;
        }
        if (v.filters) {
            if (v.filters.hiddenInApp && lookLikeInElectron) {
                return false;
            }
            if (v.filters.hiddenInWeb && isWebWmEntry) {
                return false;
            }
            if (v.filters.isUltimateVersion !== undefined) {
                if (v.filters.isUltimateVersion !== filterConditions.isUltimateVersion) {
                    return false;
                }
            }
            if (v.filters.isExaltedVersion !== undefined) {
                if (v.filters.isExaltedVersion !== filterConditions.isExaltedVersion) {
                    return false;
                }
            }
            if (v.filters.higherOrEqualUltimateVersion !== undefined) {
                if (v.filters.higherOrEqualUltimateVersion !== filterConditions.higherOrEqualUltimateVersion) {
                    return false;
                }
            }
            if (v.filters.isAdmin !== undefined) {
                if (v.filters.isAdmin !== filterConditions.isAdmin) {
                    return false;
                }
            }
            if (v.filters.isRbac !== undefined) {
                if (v.filters.isRbac !== filterConditions.isRbac) {
                    return false;
                }
            }
            if (v.filters.excludeProductVersion !== undefined) {
                if (filterConditions.version && v.filters.excludeProductVersion.includes(filterConditions.version)) {
                    return false;
                }
            }
            if (v.filters.includeProductVersion !== undefined) {
                if (filterConditions.version && !v.filters.includeProductVersion.includes(filterConditions.version)) {
                    return false;
                }
            }
        }
        return true;
    })
        .map(v => (Object.assign(Object.assign({}, v), { hiddenByUser: v.label && filterConditions.useDefinedMenuKeys ? !filterConditions.useDefinedMenuKeys[v.label] : false, children: Array.isArray(v.children) ? filterCommonMenus(v.children, filterConditions) : undefined })));
    return filterConditions.hiddenByUser ? handleHiddenByUser(result) : result;
};
export const handleHiddenByUser = (menus) => menus
    .filter(v => !v.hiddenByUser)
    .map(v => (Object.assign(Object.assign({}, v), { children: Array.isArray(v.children) ? handleHiddenByUser(v.children) : undefined })));
export const getAllMenuKeys = (curMenu, keys) => {
    var _a;
    const result = keys || [];
    (_a = curMenu === null || curMenu === void 0 ? void 0 : curMenu.children) === null || _a === void 0 ? void 0 : _a.forEach(item => {
        var _a;
        result.push(item.path);
        if ((_a = item.children) === null || _a === void 0 ? void 0 : _a.length) {
            getAllMenuKeys(item, result);
        }
    });
    return result;
};
export const getFirstNotHiddenActiveKey = (menu) => {
    if (!Array.isArray(menu.children) || menu.children.length === 0) {
        if (!menu.hiddenByUser) {
            return menu.path;
        }
        return '';
    }
    for (let i = 0; i < menu.children.length; i++) {
        const child = menu.children[i];
        const leafNodeKey = getFirstNotHiddenActiveKey(child);
        if (leafNodeKey) {
            return leafNodeKey;
        }
    }
    return '';
};
export const findMatchedMenu = (menu, path) => {
    if (menu.path === path) {
        return menu;
    }
    if (menu.children && menu.children.length > 0) {
        for (let i = 0; i < menu.children.length; i++) {
            const child = menu.children[i];
            const result = findMatchedMenu(child, path);
            if (result) {
                return result;
            }
        }
    }
    return null;
};
export const findActiveKeys = (curMenu, page) => {
    var _a;
    if (page === 'emailFilter') {
        return {
            xPath: 'emailFilter,ioEmail',
        };
    }
    const stack = [curMenu];
    while (stack.length) {
        const current = stack.pop();
        if ((current === null || current === void 0 ? void 0 : current.path) === page || ((_a = current === null || current === void 0 ? void 0 : current.subset) === null || _a === void 0 ? void 0 : _a.includes(page))) {
            return current;
        }
        if ((current === null || current === void 0 ? void 0 : current.children) && !current.hiddenByUser) {
            stack.push(...current.children.map(x => (Object.assign(Object.assign({}, x), { xPath: x.path + ',' + current.path }))));
        }
    }
    return stack;
};
export const hiddenMenuByPath = (data = [], pathList = []) => data
    .filter(v => !pathList.includes(v.path))
    .map(v => (Object.assign(Object.assign({}, v), { children: v.children ? hiddenMenuByPath(v.children, pathList) : undefined })));
export const hiddenMenuByLabel = (data = [], labelList = []) => data
    .filter(v => v.label && !labelList.includes(v.label))
    .map(v => (Object.assign(Object.assign({}, v), { children: v.children ? hiddenMenuByLabel(v.children, labelList) : undefined })));
